import { BankProducts } from '@modules/banks/presentation/v2/features/BankProducts';
import { Flex } from '@huspy/briks-web';
import { InterbankRate } from '@modules/banks/presentation/v2/pages/BankProducts/features/InterbankRate';
import { BUSINESS_IDENTIFIER } from '@modules/core/api/const';
import { useNavigate } from '@tanstack/react-router';
import { HomeRoute } from '@modules/core/presentation/v1/routes';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';
import { useEffect } from 'react';
import MainContentPageWrapper from '@components/v2/MainContentPageWrapper';
import { WhatsAppChatBot } from '@modules/core/presentation/v2/layout/features/WhatsAppChatBot';
import { useTranslation } from 'react-i18next';
import { bankProductsTable } from './styles';

const BankProductsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (APPLICATION_BUSINESS_IDENTIFIER !== BUSINESS_IDENTIFIER.AE_HUSPY) {
      navigate({ to: HomeRoute.to });
    }
  }, [navigate]);

  useEffect(() => {
    trackAmplitudeEvent(USER_EVENTS.BANK_PRODUCTS.SIDEBAR_CLICKED);
  }, []);

  if (APPLICATION_BUSINESS_IDENTIFIER !== BUSINESS_IDENTIFIER.AE_HUSPY) {
    navigate({ to: '/' });
  }

  return (
    <MainContentPageWrapper
      title={ t('bankProducts.title') }
      subtitle={ t('bankProducts.subtitle') }
      asideTitleContent={ (
        <Flex align='center' gap={ 3 }>
          <InterbankRate />
        </Flex>
      ) }
    >
      <WhatsAppChatBot />
      <BankProducts
        tableClassName={ bankProductsTable }
        initialValues={ { status_type: ['1'] } }
      />
    </MainContentPageWrapper>
  );
};

export default BankProductsPage;
